import script from "./About-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./About-popup.vue?vue&type=script&setup=true&lang=js"

import "./About-popup.vue?vue&type=style&index=0&id=563db015&lang=scss&scoped=true"

import exportComponent from "/home/herman/Документи/Work/UHMI/uhmi-web-maps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563db015"]])

export default __exports__